import * as yup from 'yup'

export const ValidationSchema = {
  funcao: yup.string().required('Campo é obrigatório'),
  nome: yup.string().required('Campo é obrigatório'),
  empresa: yup.string().required('Campo é obrigatório'),
  telefone: yup.string().required('Campo é obrigatório'),
}
